<template>
	<div class="popup" @click="handleClose">
		<div class="popup-item" @click="handleItemClick">
			<div class="popup-text">
				Если вы выберете Matific то все типы игр на дату
				{{ homeworkDate }} удалятся
			</div>
			<div class="wrap-btn">
				<button type="button" class="btn-primary btn" @click="handleResume">
					{{ 'games.resume' | translate }}
				</button>
				<button type="button" class="btn-danger btn" @click="handleClose">
					{{ 'Cancel' | translate }}
				</button>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.popup {
	z-index: 999;
	position: fixed;
	right: 0;
	left: 0;
	top: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(#000, 0.7);

	&-item {
		padding: 30px;
		background-color: #fff;
	}

	.wrap-btn {
		margin-top: 10px;

		button {
			&:first-child {
				margin-right: 20px;
			}
		}
	}
}
</style>

<script>
export default {
	props: ['cancel', 'resume'],
	name: 'WarningMatific',
	methods: {
		handleClose(e) {
			this.cancel()
		},
		handleResume() {
			this.resume()
		},
		handleItemClick(e) {
			e.stopPropagation()
			e.preventDefault()
		},
	},
	computed: {
		homeworkDate() {
			const date = new URLSearchParams(window.location.search)
			return date.has('date') ? date.get('date') : ''
		},
	},
}
</script>
